import { InjectionToken } from '@angular/core';
import { IAppConfig } from './app-config.model';

export const APP_CONFIG = new InjectionToken<IAppConfig>('AppConfig');
